export default "__VITE_ASSET__v8Eed4AH__"